import React from "react";
import styles from "../styles";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">
          ЛИЦЕНЗИОННОЕ СОГЛАШЕНИЕ С КОНЕЧНЫМ ПОЛЬЗОВАТЕЛЕМ ПРОГРАММНОГО
          ОБЕСПЕЧЕНИЯ TREND AnyWARE®
        </span>

        <span className="lineBreak">
          НАЖИМАЯ «ПРИНЯТЬ», ВЫ СОГЛАШАЕТЕСЬ СОБЛЮДАТЬ УСЛОВИЯ НАСТОЯЩЕГО
          ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ, КОТОРЫЕ ТАКИМ ОБРАЗОМ СТАНОВЯТСЯ
          ОБЯЗАТЕЛЬНЫМИ ДЛЯ ВАС
        </span>

        <span className="lineBreak">
          Настоящее Соглашение с конечным пользователем (в действующей редакции,
          устанавливаемой в порядке статьи 12) («
          <b>Пользовательское соглашение</b>») является обязательным к
          исполнению соглашением, которое заключается между вами (физическим
          лицом или отдельной организацией) и компанией TREND Networks Limited
          («<b>TREND</b>») и регулирует осуществление вами доступа и
          использование вами программного обеспечения TREND AnyWARE®,
          являющегося предметом настоящего Пользовательского соглашения, которое
          может включать в себя сопутствующие носители, печатные материалы,
          электронную документацию (или документацию, размещенную в Интернете),
          а также Интернет-сервисы («<b>ПО</b>»). ПО позволяет подключаться к
          совместимому оборудованию для тестирования, устройствам и инструментам
          TREND («<b>Инструменты</b>») и получать данные из таких Инструментов.
          Доступ к ПО может быть осуществлен через веб-браузер на любом
          устройстве; ПО также может быть загружено и установлено на компьютере.
        </span>

        <span className="lineBreak">
          <b>
            ВАЖНОЕ УВЕДОМЛЕНИЕ. ВНИМАТЕЛЬНО ОЗНАКОМЬТЕСЬ С УСЛОВИЯМИ НАСТОЯЩЕГО
            ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ.
          </b>
          ОНО СОДЕРЖИТ ВАЖНЫЕ УСЛОВИЯ, ВЛИЯЮЩИЕ НА ВАС И ИСПОЛЬЗОВАНИЕ ВАМИ ПО.
          ПРИ ВЫПОЛНЕНИИ УСЛОВИЙ НАСТОЯЩЕГО ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ ВЫ
          ДОЛЖНЫ ОРИЕНТИРОВАТЬСЯ НА АКТУАЛЬНУЮ ВЕРСИЮ СОГЛАШЕНИЯ. СОЗДАВАЯ
          УЧЕТНУЮ ЗАПИСЬ, УСТАНАВЛИВАЯ ПО (ЦЕЛИКОМ ИЛИ ЧАСТИЧНО), ПОЛУЧАЯ ДОСТУП
          К ПО ИЛИ ИСПОЛЬЗУЯ ЕГО ИНЫМ ОБРАЗОМ, ВЫ ГАРАНТИРУЕТЕ ОТ СВОЕГО
          СОБСТВЕННОГО ИМЕНИ (В СООТВЕТСТВУЮЩЕМ СЛУЧАЕ — ОТ ИМЕНИ КОМПАНИИ ИЛИ
          ОРГАНИЗАЦИИ, В КОТОРОЙ ВЫ РАБОТАЕТЕ ИЛИ КОТОРУЮ ПРЕДСТАВЛЯЕТЕ), ЧТО
          ОЗНАКОМИЛИСЬ С УСЛОВИЯМИ НАСТОЯЩЕГО ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ,
          ПОНЯЛИ ИХ И ДАЛИ СОГЛАСИЕ НА ИХ ОБЯЗАТЕЛЬНОСТЬ. ЕСЛИ ВЫ НЕ ДАЕТЕ
          ТАКОГО СОГЛАСИЯ, ВЫ НЕ ВПРАВЕ ОСУЩЕСТВЛЯТЬ ДОСТУП К ПО, УСТАНАВЛИВАТЬ,
          КОПИРОВАТЬ ИЛИ ИСПОЛЬЗОВАТЬ ЕГО. ЕСЛИ ВЫ НЕ СОГЛАСНЫ С ТЕМ ИЛИ ИНЫМ
          ИЗМЕНЕНИЕМ НАСТОЯЩЕГО ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ, ВЫ ЛИШАЕТЕСЬ ПРАВА
          НА ПОЛУЧЕНИЕ ДОСТУПА ИЛИ ИСПОЛЬЗОВАНИЕ ПО, В СВЯЗИ С ЧЕМ ВЫ ДОЛЖНЫ
          НЕМЕДЛЕННО УДАЛИТЬ И/ИЛИ ПРЕКРАТИТЬ ИСПОЛЬЗОВАНИЕ ПО.
        </span>

        <span className="lineBreak">
          ВЫ ГАРАНТИРУЕТЕ, ЧТО ЗАКЛЮЧАЕТЕ НАСТОЯЩЕЕ ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ
          В ХОДЕ ОСУЩЕСТВЛЕНИЯ ПРЕДПРИНИМАТЕЛЬСКОЙ ДЕЯТЕЛЬНОСТИ ИЛИ ДЛЯ
          КОММЕРЧЕСКИХ ЦЕЛЕЙ (НО НЕ В КАЧЕСТВЕ ПОТРЕБИТЕЛЯ). ТЕМ НЕ МЕНЕЕ, ЕСЛИ
          СОГЛАСНО ПРИМЕНИМОМУ ПРАВУ ПОДЛЕЖАТ ПРИМЕНЕНИЮ НОРМЫ ЗАКОНОДАТЕЛЬСТВА
          О ПРАВАХ ПОТРЕБИТЕЛЯ, НАСТОЯЩЕЕ ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ НЕ ВЛИЯЕТ
          НА ПРАВА ПОТРЕБИТЕЛЯ, КОТОРЫЕ МОГУТ БЫТЬ ПРЕДОСТАВЛЕНЫ ВАМ ПРИМЕНИМЫМ
          ПРАВОМ, И НЕ УЩЕМЛЯЕТ ТАКИХ ПРАВ. ЕСЛИ ВЫ ЗАКЛЮЧАЕТЕ НАСТОЯЩЕЕ
          ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ ОТ ИМЕНИ КОМПАНИИ ИЛИ ИНОГО ЮРИДИЧЕСКОГО
          ЛИЦА, ВЫ ГАРАНТИРУЕТЕ, ЧТО ИМЕЕТЕ ВСЕ ПРАВА И ПОЛНОМОЧИЯ НА ЗАКЛЮЧЕНИЕ
          НАСТОЯЩЕГО СОГЛАШЕНИЯ ОТ ИМЕНИ ТАКОЙ КОМПАНИИ ИЛИ ЮРИДИЧЕСКОГО ЛИЦА. В
          ТАКОМ СЛУЧАЕ СЛОВА «ВЫ» («ВАШ») ОЗНАЧАЮТ КОМПАНИЮ (ЮРИДИЧЕСКОЕ ЛИЦО),
          КОТОРУЮ ВЫ ПРЕДСТАВЛЯЕТЕ ИЛИ В КОТОРОЙ ВЫ РАБОТАЕТЕ, ЕЕ АФФИЛИРОВАННЫХ
          ЛИЦ, А ТАКЖЕ КАЖДОГО ИЗ ИХ ДИРЕКТОРОВ, ДОЛЖНОСТНЫХ ЛИЦ, СОТРУДНИКОВ,
          АГЕНТОВ И ПРЕДСТАВИТЕЛЕЙ.
        </span>

        <ol>
          <li>
            <b> ИСПОЛЬЗОВАНИЕ ПО</b>
            <ol>
              <li>
                При условии соблюдения вами условий настоящего Пользовательского
                соглашения, компания TREND предоставляет вам неэксклюзивную и
                ограниченную лицензию без права передачи и сублицензирования
                (которая также может быть отозвана) на загрузку, установку,
                активацию, получение доступа или иное использование версий
                объектного кода ПО на устройстве, принадлежащем или
                контролируемом вами, исключительно в рамках вашей внутренней
                деятельности и в порядке, установленном настоящим
                Пользовательским соглашением.
              </li>
              <li>
                Вы можете предоставить третьему лицу и/или пользователям в вашей
                компании или организации («
                <b>Разрешенные пользователи</b>») право на доступ к ПО
                (использование ПО) в рамках выполнения их ежедневных
                обязанностей при условии, что такое использование осуществляется
                исключительно: (i) от вашего имени, (ii) в рамках вашей
                внутренней деятельности и (iii) в соответствии с настоящим
                Пользовательским соглашением. При предоставлении Разрешенным
                пользователем доступа к ПО вы обязаны обеспечить, чтобы все ваши
                Разрешенные пользователи дали согласие на соблюдение условий
                настоящего Пользовательского соглашения, а также были уведомлены
                о сборе, использовании и распространении компанией TREND их
                персональных данных в соответствии с условиями Политики
                конфиденциальности TREND и дали согласие на такие сбор,
                использование и распространение. При упоминании в настоящем
                Пользовательском соглашении слов «вы» или «ваш» также имеются в
                виду и Разрешенные пользователи в вашей организации. Ваши
                обязанности: (a) идентификация и аутентификация всех Разрешенных
                пользователей; (b) утверждение доступа к ПО со стороны таких
                Разрешенных пользователей; (c) обеспечение соблюдения
                Разрешенными пользователями условий настоящего Пользовательского
                соглашения; (d) недопущение несанкционированного доступа или
                использования ПО со стороны Разрешенных пользователей; (e)
                обеспечение конфиденциальности имен пользователей, паролей и
                прочих данных учетной записи; а также (f) направление
                необходимых уведомлений Разрешенным пользователям (получение от
                них согласий) в случаях, установленных применимым
                законодательством, в том числе для активации на Инструментах
                функции определения местоположения. Компания TREND не несет
                ответственности за ущерб, причиненный вашими Разрешенными
                пользователями, в том числе теми, кто не имел права доступа к
                ПО, но кто смог получить такой доступ из-за несвоевременной
                деактивации имени пользователя, пароля или учетной записи в
                вашей системе управления идентификацией пользователей, на ваших
                устройствах или иным образом (вами или от вашего имени). Вы
                отвечаете за все действия, которые совершаются под именами
                пользователя, паролями или учетными записями ваших Разрешенных
                пользователей, в связи с ними или в результате получения вами
                или вашими Разрешенными пользователями доступа к ПО, и
                обязуетесь незамедлительно сообщать TREND в письменной форме о
                любом несанкционированном использовании ПО. Вы обязуетесь
                принимать все разумные меры для недопущения доступа к ПО со
                стороны третьих лиц, не имеющих соответствующих прав. Вы
                отвечаете за все действия (бездействие) любого Разрешенного
                пользователя и обязуетесь возмещать компании TREND любые
                издержки, затраты, убытки или ущерб (прямые и косвенные, в том
                числе экономические потери, упущенную выгоду, потерю репутации),
                которые понесла компания TREND или за которые компания TREND
                отвечает в результате действия (бездействия) любого Разрешенного
                пользователя.
              </li>
              <li>
                Вы обязаны назначить одного или более Разрешенных пользователей
                администратором (-ами) («<b>Администратор</b>») вашей учетной
                записи. Вы соглашаетесь с тем, что Администратор вправе от
                вашего имени предоставлять в любое время и на любом основании
                права доступа и пользования другим Разрешенным пользователям, а
                также отзывать такие права. Вы вправе поменять вашего (-их)
                Администратора (-ов) в любое время и по любой причине, оформив
                данное изменение в соответствующем виде.
              </li>
              <li>
                Вы соглашаетесь с тем, что исключительно вы отвечаете за
                использование вами ПО, нарушение ваших обязательств по
                настоящему Пользовательскому соглашению и за последствия
                нарушения (включая возможные для компании TREND убытки или
                ущерб), и компания TREND не несет ответственности перед вами или
                третьими лицами в связи с вышеизложенным.
              </li>
              <li>
                Доступ к ПО возможен через веб-браузер на вашем устройстве.
                Загрузка и установка автономной версии ПО возможны на компьютер,
                работающий на ОС Microsoft Windows. Автономная версия ПО
                позволяет взаимодействовать с Инструментами напрямую без
                необходимости подключения к Интернету.
              </li>
              <li>
                Для загрузки, установки, активации, получения доступа и иного
                использования ПО вам нужно будет зарегистрировать учетную
                запись. Компания TREND вправе отказать в регистрации без
                объяснения причин. В связи с использованием ПО вы обязуетесь:
                (i) предоставлять достоверные, актуальные и полные данные
                учетной записи; (ii) своевременное обновлять данные учетной
                записи; (iii) обеспечивать безопасность вашего (-их) пароля
                (-ей) и нести риск несанкционированного доступа к вашей учетной
                записи и информации, предоставляемой вами компании TREND; а
                также (iv) незамедлительно уведомлять нас о выявлении нарушений
                безопасности в связи с ПО или вашим использованием ПО либо о
                соответствующих подозрениях.
              </li>
              <li>
                Вы должны обеспечить компании TREND возможность осуществлять
                обслуживание и поддержку ПО посредством предоставления компании
                TREND необходимых прав доступа, которые бы позволили ей заходить
                в вашу учетную запись и пользоваться ею так, как если бы это
                были вы, в том числе право просматривать, изменять и удалять
                ваши данные.
              </li>
              <li>
                В разрешенных законом случаях компания TREND вправе удалять
                любые ваши данные, если ваши действия (бездействие) противоречат
                положениям настоящего Пользовательского соглашения. Компания
                TREND постарается уведомить вас об удалении ваших данных, но в
                любом случае не будет нести ответственности за неуведомление.
                Если вы загружаете данные и удаляете их с наших или сторонних
                серверов, вы не сможете получить доступ к таким загруженным и
                удаленным данным через ПО или наши (сторонние) сервера.
              </li>
              <li>
                Только вы отвечаете за предоставление и обслуживание за
                собственный счет всех инструментов, оборудования, программного
                обеспечения, сервисов и прочих элементов, необходимых для
                использования ПО и Инструментов, включая компьютерное
                оборудование (оборудование устройства), ПО, модемы, телефонную
                связь и доступ в Интернет.
              </li>
              <li>
                Вы признаете, что для использования ПО может потребоваться
                интернет-соединение и что передача (прием и отправка) данных
                вашим устройством при использовании ПО может быть для вас
                платной. Оплата стоимости передачи данных является исключительно
                вашей обязанностью.
              </li>
            </ol>
          </li>

          <li>
            <b> СОХРАНЕНИЕ ПРАВ, В ТОМ ЧИСЛЕ ПРАВА СОБСТВЕННОСТИ</b>
            <ol>
              <li>
                Настоящим Вам предоставляется только лицензия на использование
                ПО в соответствии с условиями настоящего Пользовательского
                соглашения, то есть вы не покупаете само ПО. Право собственности
                и прочие права на: (i) ПО (включая права на соответствующие
                объекты интеллектуальной собственности); а также (ii) весь
                контент и прочие материалы в ПО, предоставляемые компанией TREND
                или сторонними правообладателями, включая логотипы TREND и TREND
                AnyWARE®, все дизайны, текст, графику, изображения, информацию,
                данные, программное обеспечение, звуковые и прочие файлы, а
                также определенные наборы или конфигурации перечисленных
                элементов (совместно — «Контент») принадлежат компании TREND или
                в соответствующих случаях нашим лицензиарам. Перечисленные
                элементы охраняются авторским правом, прочими интеллектуальными
                правами и применимым законодательством. Компания TREND сохраняет
                за собой все права, которые напрямую не закрепляются за вами в
                настоящем Пользовательском соглашении; какие-либо иные права не
                предоставляются (ни прямым, ни подразумеваемым образом).
              </li>
              <li>
                Наименования «TREND», «TREND Networks», «TREND AnyWARE»,
                «LanTEK», «TREND Networks», «FiberTEK», «SignalTEK», «NaviTEK»,
                «SecuriTEST», «LanXPLORER», «UniPRO MGig1», логотипы TREND
                Networks и TREND AnyWARE® и прочие наименования, логотипы или
                слоганы продуктов (сервисов) TREND, которые встречаются в ПО или
                Контенте, являются товарными знаками, принадлежащими компании
                TREND. Полное или частичное копирование, имитация или
                использование указанных объектов или наименований, логотипов,
                слоганов, схожих с указанными до степени смешения, возможны
                исключительно с предварительного письменного разрешения компании
                TREND. Сторонние знаки, которые встречаются в ПО или Контенте,
                принадлежат соответствующим третьим сторонам, и их использование
                возможно исключительно с разрешения соответствующего
                правообладателя. Использование метатегов или другого скрытого
                текста, включающего в себя наименование «TREND» или наименование
                любого другого продукта или сервиса TREND, возможно
                исключительно с нашего предварительного письменного разрешения.
                Кроме того, внешний вид ПО, включая заголовки всех страниц,
                специальную графику, значки кнопок и сценарии, является знаком
                обслуживания, товарным знаком и/или фирменным видом, которые
                принадлежат компании TREND, и их полные или частичные
                копирование, имитация или использование запрещены без нашего
                предварительного письменного разрешения. Упоминание о каком-либо
                продукте, сервисе, процессе или иной информации путем указания
                его наименования, товарного знака, производителя, поставщика или
                иных данных не означает, что TREND одобряет или рекомендует их
                или является их спонсором.
              </li>
            </ol>
          </li>

          <li>
            <b> ОГРАНИЧЕНИЯ </b>
            <ol>
              <li>
                Вы понимаете и соглашаетесь с тем, что вы вправе использовать ПО
                исключительно в соответствии с действующим законодательством
                юрисдикции, в которой вы используете ПО. При нарушении
                настоящего Пользовательского соглашения вас могут привлечь к
                ответственности, в том числе потребовать возмещения убытков.
              </li>
              <li>
                Вы не вправе совершать следующие действия и разрешать третьим
                лицам совершать такие действия:
                <ol>
                  <li>
                    загружать, устанавливать, активировать, получать доступ или
                    иным образом использовать ПО или Контент на устройстве,
                    которое вам не принадлежит или которое не находится под
                    вашим контролем на законных основаниях;
                  </li>
                  <li>
                    публиковать, обсуждать, транслировать или иным образом
                    распространять среди третьих лиц результаты тестирования,
                    полученные в ходе использования Инструментов;
                  </li>
                  <li>
                    переводить, адаптировать, изменять ПО полностью или
                    частично, объединять ПО или его часть с другими программами,
                    разрешать его объединение с другими программами или его
                    включение в другие программы;
                  </li>
                  <li>
                    осуществлять обратное проектирование, декомпилирование,
                    дизассемблирование или изменение ПО или его части, пытаться
                    получить исходный код ПО или его части, за исключением
                    случаев, когда это прямо разрешено применимым
                    законодательством;
                  </li>
                  <li>
                    удалять указания на правообладателя или иные знаки в ПО или
                    менять такие указания или знаки;
                  </li>
                  <li>
                    создавать производные работы на основе ПО или его части;
                  </li>
                  <li>
                    копировать или воспроизводить ПО за пределами вашей
                    организации;
                  </li>
                  <li>
                    продавать, уступать, распространять ПО, сдавать его в
                    аренду, предоставлять его в пользование на условиях
                    лицензирования, сублицензирования или на иных условиях (в
                    любой форме, полностью или частично) какому-либо лицу без
                    предварительного письменного разрешения компании TREND;
                  </li>
                  <li>
                    использовать ПО в неправомерных целях, неправомерным образом
                    или не в соответствии с настоящими условиями, действовать
                    мошенническим или зловредным образом, в том числе путем
                    взлома ПО или операционной системы, вставки вредоносного
                    кода (например, вирусов) или данных;
                  </li>
                  <li>
                    нарушать принадлежащие нам или третьим лицам права на
                    объекты интеллектуальной собственности при использовании
                    вами ПО, в том числе путем передачи каких-либо материалов
                    (если права на такое использование не предусмотрены
                    настоящими условиями);
                  </li>
                  <li>
                    передавать в связи с использованием вами ПО клеветнические
                    или оскорбительные материалы или материалы сомнительного
                    содержания;
                  </li>
                  <li>
                    использовать ПО, если это может повредить, отключить,
                    перегрузить или нарушить работу ПО (или серверов (сетей),
                    подключенных к ПО);
                  </li>
                  <li>
                    использовать ПО, если это может помешать использованию ПО
                    (или серверов (сетей), подключенных к ПО) другими лицами;
                  </li>
                  <li>
                    разрабатывать сторонние приложения для взаимодействия с ПО
                    без предварительного письменного согласия компании TREND;
                  </li>
                  <li>
                    собирать данные посредством использования ПО или систем
                    TREND или пытаться расшифровать какие-либо передачи данных
                    на сервера или с серверов, которые обслуживают ПО; или
                  </li>
                  <li>
                    использовать ПО в целях, для которых оно не предназначено,
                    или в любых целях, не предусмотренных настоящим
                    Пользовательским соглашением.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b> СБОР И ИСПОЛЬЗОВАНИЕ ДАННЫХ</b>
            <ol>
              <li>
                Вы соглашаетесь с тем, что компания TREND и ее аффилированные
                лица вправе собирать и использовать технические данные,
                собираемые в рамках предоставляемых вам услуг по поддержке нашей
                продукции (в случае предоставления), а именно ПО. Компания TREND
                может использовать такие данные исключительно для улучшения
                нашей продукции или для предоставления вам адаптированных под
                конкретные нужды услуг (технологий) и не будет передавать такие
                данные в той форме, которая позволит идентифицировать вас или
                иных пользователей.
              </li>
              <b class="subHeading">Персональные данные</b>
              <li>
                Вы соглашаетесь с тем, что при загрузке, установке, активации,
                получении доступа или ином использовании вами ПО компания TREND
                может использовать автоматические способы сбора данных с вашего
                устройства об использовании вами ПО (например, файлы cookie или
                веб-маяки). Одним из условий загрузки, установки, активации,
                получения доступа или использования вами или вашими Разрешенными
                пользователями ПО (определенных функций ПО) может быть
                предоставление определенных персональных данных.
                Законодательство о защите данных обязывает нас предоставить вам
                определенную информацию о нашей компании, о том, как и для каких
                целей мы обрабатываем ваши персональные данные, о ваших правах в
                отношении ваших персональных данных и способах их реализации.
                Данная информация представлена в политике конфиденциальности
                компании TREND, размещенной по адресу:
                <a
                  href="https://www.trend-networks.com/UK/EN/Privacy-Policy.aspx"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/UK/EN/Privacy-Policy.aspx
                  </b>
                </a>
                , изменения в которую могут вноситься без уведомления
                пользователей («<b>Политика конфиденциальности</b>»). Вы должны
                ознакомиться с Политикой конфиденциальности. Загружая,
                устанавливая, активируя, получая доступ или используя ПО, а
                также передавая информацию в ПО или через ПО, вы даете свое
                согласие на любые виды использования ваших данных и прочих
                действий в отношении ваших данных со стороны компании TREND в
                порядке, предусмотренном Политикой конфиденциальности.
              </li>
              <li>
                Мы напоминаем вам о том, что при передаче данных через Интернет
                абсолютные конфиденциальность или безопасность не могут быть
                обеспечены и что любые передаваемые вами через ПО сообщения или
                данные могут быть прочитаны или перехвачены другими лицами (даже
                при наличии специального уведомления о том, что в том или иное
                случае передача данных зашифрована).
              </li>
              <b class="subHeading">Данные конечного пользователя</b>
              <li>
                В связи с использованием ПО компания TREND вправе собирать и
                хранить данные, введенные или загруженные вами (от вашего имени)
                через ПО, включая данные, касающиеся вашего использования
                Инструментов и Разрешенных пользователей Инструментов («
                <b>Данные конечного пользователя</b>»). Вы соглашаетесь с тем,
                что исключительно Вы отвечаете за все Данные конечного
                пользователя. Компания TREND обязуется обеспечивать
                конфиденциальность всех аспектов всех Данных конечного
                пользователя, которые позволяют идентифицировать то или иное
                лицо, в соответствии с Политикой конфиденциальности. Все третьи
                лица, которым компанией TREND разрешен доступ к Данным конечного
                пользователя, обязаны обеспечивать конфиденциальность таких
                Данных, а также соблюдать все соответствующие законы о защите
                данных. Настоящим вы предоставляете компании TREND безотзывную
                лицензию (без срока действия, на безвозмездной основе, с правом
                передачи и сублицензирования) и даете свое согласие на
                использование, воспроизведение, изменение, адаптацию, перевод,
                раскрытие, коммерциализацию, уступку, продажу, сдачу в аренду,
                лицензирование и передачу Данных конечного пользователя
                (полностью или частично), если они не содержат персональных
                данных. Загружая или передавая Данные конечного пользователя с
                использованием ПО, вы заявляете и гарантируете следующее: (i) на
                эти Данные конечного пользователя не распространяются
                обязательства об обеспечении конфиденциальности, которые были бы
                нарушены использованием таких Данных в соответствии с условиями
                настоящего Пользовательского соглашения; (ii) вы контролируете и
                отвечаете за все права на Данные конечного пользователя, которые
                вы создаете, загружаете или передаете; либо вы в любом случае
                обладаете всеми необходимыми правам для создания, загрузки или
                передачи таких Данных с использованием ПО; (iii) Данные
                конечного пользователя являются достоверными, не предназначены
                для введения в заблуждение или причинения вреда тем или иным
                образом; а также (iv) сами по себе Данные конечного пользователя
                (либо их использование, загрузка или передача вами) не нарушают
                и не нарушат условия настоящего Пользовательского соглашения или
                применимого законодательства. Несмотря на любые иные положения
                настоящего Пользовательского соглашения, компания TREND вправе в
                любое время: (a) удалить любые Данные конечного пользователя; и
                (или) (b) временно заблокировать вашу учетную запись и доступ к
                ПО. Вы отвечаете за наличие копий любых загруженных, переданных
                или предоставленных компании TREND через ПО Данных конечного
                пользователя, и компания TREND не несет никакой ответственности
                перед вами за потерю каких-либо Данных конечного пользователя
                или утрату вами возможности использования ПО.
              </li>
              <b class="subHeading">Данные компании TREND </b>
              <li>
                Вся информация, включая данные, аналитические данные, измерения,
                отчеты, сведения о тенденциях и показателях, полученные в
                результате использования или на основе Данных конечного
                пользователя или касающиеся таких Данных («
                <b>Данные компании TREND</b>»), являются исключительной
                собственностью компании TREND. Компания TREND вправе
                использовать, хранить, создавать, агрегировать, исследовать,
                анализировать, изменять, коммерциализировать, уступать,
                продавать, сдавать в аренду, передавать на условиях лицензии или
                иным образом Данные компании TREND в любой форме, любым образом
                и для любых целей.
              </li>
            </ol>
          </li>

          <li>
            <b> ОБНОВЛЕНИЯ</b>
            <ol>
              <li>
                Компания TREND вправе вносить изменения в ПО без
                предварительного уведомления, включая изменение функциональности
                или внешнего вида ПО.
              </li>
              <li>
                Компания TREND вправе периодически и по собственному усмотрению
                разрабатывать и предоставлять обновления для ПО, включая
                модернизацию, устранение ошибок, корректирующие вставки,
                исправление других неточностей и/или новые функции (вместе с
                необходимой документацией именуемые «<b>Обновления</b>»).
                Обновления также могут изменять или удалять в полном объеме
                определенные характеристики и функции. Вы соглашаетесь с тем,
                что компания TREND не обязана предоставлять вам какие-либо
                Обновления или обеспечивать работу каких-либо конкретных
                характеристик или функций. В зависимости от настроек вашего
                устройства, когда ваше устройство подключено к Интернету, либо:
                (i) ПО автоматически загрузит и установит все доступные
                Обновления; либо (ii) вы можете получить уведомление или запрос
                на загрузку и установку доступных Обновлений. Для того чтобы
                пользоваться ПО в полном объеме, вы должны своевременно
                загружать и устанавливать все Обновления. Вы признаете, что ПО
                или его части могут работать неправильно, если вы этого не
                сделаете. Вы также соглашаетесь с тем, что все Обновления будут
                считаться частью ПО и будут подчиняться всем условиям и
                положениям настоящего Пользовательского соглашения.
              </li>
            </ol>
          </li>

          <li>
            <b> СТОРОННИЕ САЙТЫ И ПОДДЕРЖКА </b>
            <ol>
              <li>
                Используя ПО, вы можете попасть на сторонние сайты, например на
                «Team Viewer» (платформу удаленной поддержки компьютеров и
                внешнего управления принтерами). Сторонние сайты не находятся
                под контролем Компании TREND, и Компания TREND не несет
                ответственности за контент сторонних сайтов, за любые ссылки,
                содержащиеся на сторонних сайтах, а также за любые изменения или
                обновления сторонних сайтов. Компания TREND не несет
                ответственности за веб-трансляцию или любую другую форму
                передачи с любых сторонних сайтов. Компания TREND предоставляет
                вам ссылки на сторонние сайты только для удобства, а наличие
                ссылки не означает того, что компания TREND одобряет такой сайт.
              </li>
              <li>
                Дополнительная информация о ПО, в том числе о решении возможных
                проблем, размещена на сайте{" "}
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>{" "}
                На данном сайте размещены контактные данные по регионам.
                Компания TREND не обязана предоставлять какие-либо услуги
                поддержки по настоящему Пользовательскому соглашению. Если вам
                потребуется какая-либо услуга поддержки, она может быть
                предоставлена по запросу на платной основе. Настоящее
                Пользовательское соглашение не дает вам никаких прав на
                какие-либо обновления или модернизацию ПО или на какие-либо
                расширения и усовершенствования ПО, разработанные компанией
                TREND или от ее имени, в будущем. Компания TREND может
                предлагать услуги поддержки на основе отдельного соглашения.
                Любой дополнительный код ПО или сопутствующие материалы, которые
                Компания TREND предоставляет вам в части услуг поддержки, должны
                рассматриваться как часть ПО и подчиняться условиям настоящего
                Пользовательского соглашения.
              </li>
            </ol>
          </li>

          <li>
            <b> КОНФИДЕНЦИАЛЬНАЯ ИНФОРМАЦИЯ </b> <br />
            Вы признаете и соглашаетесь с тем, что ПО (исключая любое ПО с
            открытым исходным кодом) и вся информация, касающаяся ПО и бизнеса
            Компании TREND и предоставляемая в любой форме, являются ценными
            объектами интеллектуальной собственности компании TREND и считаются
            конфиденциальной информацией компании TREND («
            <b>Конфиденциальная информация</b>»). В течение или после окончания
            срока действия настоящего Пользовательского соглашения вы обязуетесь
            не разрешать копирования, использования или раскрытия такой
            Конфиденциальной информации какому-либо лицу, если только такое
            копирование, использование или раскрытие не будут до раскрытия
            информации предварительно разрешены компанией TREND в письменной
            форме. Вы должны принимать разумные меры предосторожности (и ни в
            коем случае не менее строгие, нежели в отношении вашей собственной
            конфиденциальной информации такого же характера) в целях
            предотвращения несанкционированного раскрытия или воспроизведения
            Конфиденциальной информации. Не ограничивая общего смысла
            вышеизложенного, если настоящее Пользовательское соглашение
            разрешает копирование Конфиденциальной информации, все такие копии
            должны содержать одинаковые оговорки о конфиденциальности, а также
            указания и обозначения прав на объекты интеллектуальной
            собственности, которые имеются на первоначальных версиях, и сторона
            должна вести подробный учет местонахождения всей Конфиденциальной
            информации.
          </li>

          <li>
            <b> ПРАВО НА РАСТОРЖЕНИЕ ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ</b>
            <ol>
              <li>
                Настоящее Пользовательское соглашение будет действовать до
                момента его расторжения по вашей инициативе или по инициативе
                Компании TREND в соответствии с изложенными ниже положениями.
              </li>
              <li>
                Вы вправе расторгнуть Пользовательское соглашение в любое время,
                отказавшись от доступа к ПО и/или окончательно и полностью
                удалив ПО из вашего компьютера.
              </li>
              <li>
                Ваши права автоматически и незамедлительно прекращаются без
                необходимости получения соответствующего уведомления от компании
                TREND, если вы нарушите какое-либо из условий данного
                Пользовательского соглашения. В таком случае вы обязаны сразу же
                отказаться от доступа к ПО и/или удалить ПО.
              </li>
              <li>
                Компания TREND может в любое время отозвать ваши права на
                пользование ПО, с уведомлением или без уведомления. Условия
                настоящего Пользовательского соглашения касательно использования
                данных, возмещения ущерба, ограничения ответственности,
                конфиденциальности, разрешения споров, а также толкования и
                возникновения соглашения сохраняют силу и применяются и после
                расторжения Пользовательского соглашения или истечения его срока
                действия.
              </li>
            </ol>
          </li>

          <li>
            <b> ВОЗМЕЩЕНИЕ УЩЕРБА </b>
            <br />В разрешенных законом случаях вы обязуетесь освобождать
            компанию TREND, ее дочерние компании, аффилированных лиц, а также их
            директоров, должностных лиц, сотрудников и агентов от
            ответственности и возмещать им убытки, ущерб, затраты и издержки
            (включая расходы на оплату юридических услуг в разумном размере) по
            любым требованиям, судебным процессам и прочим разбирательствам,
            которые связаны с использованием вами или кем-либо, действующим под
            вашей учетной записью или паролем, ПО, в том числе с получением
            доступа к ПО и/или установкой или использованием ПО, либо с
            нарушением вами условий настоящего Пользовательского соглашения.
          </li>

          <li>
            <b> ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ</b>
            <ol>
              <li>
                КОМПАНИЯ TREND НЕ ИСКЛЮЧАЕТ И НЕ ОГРАНИЧИВАЕТ СВОЕЙ
                ОТВЕТСТВЕННОСТИ ПЕРЕД ВАМИ, ЕСЛИ ЭТО ЗАПРЕЩЕНО ЗАКОНОМ, В ТОМ
                ЧИСЛЕ ОТВЕТСТВЕННОСТИ ЗА ПРИЧИНЕНИЕ СМЕРТИ ИЛИ ВРЕДА ЗДОРОВЬЮ ПО
                НЕОСТОРОЖНОСТИ СО СТОРОНЫ КОМПАНИИ TREND ИЛИ ЕЕ СОТРУДНИКОВ,
                АГЕНТОВ, СУБПОДРЯДЧИКОВ, ИЛИ ОТВЕТСТВЕННОСТИ ЗА МОШЕННИЧЕСКИЕ
                ДЕЙСТВИЯ ИЛИ ПРЕДОСТАВЛЕНИЕ ЗАВЕДОМО ЛОЖНОЙ ИНФОРМАЦИИ.
              </li>
              <li>
                ВЫ ПОНИМАЕТЕ И НАПРЯМУЮ СОГЛАШАЕТЕСЬ С ТЕМ, ЧТО ВЫ ИСПОЛЬЗУЕТЕ
                ПРОГРАММНОЕ ОБЕСПЕЧЕНИЕ ПО СОБСТВЕННОМУ ЖЕЛАНИЮ И НА СВОЙ
                СОБСТВЕННЫЙ РИСК И ЧТО ПО ПРЕДОСТАВЛЯЕТСЯ НА УСЛОВИЯХ «КАК ЕСТЬ»
                И «ПО НАЛИЧИЮ» БЕЗ КАКИХ-ЛИБО ПРЯМО ВЫРАЖЕННЫХ ИЛИ
                ПОДРАЗУМЕВАЕМЫХ ГАРАНТИЙ. ИСКЛЮЧИТЕЛЬНО ВЫ ОТВЕЧАЕТЕ ЗА УЩЕРБ,
                ПРИЧИНЕННЫЙ ВАШЕМУ КОМПЬЮТЕРУ ИЛИ ИНОМУ УСТРОЙСТВУ, И ЗА ПОТЕРЮ
                ДАННЫХ В РЕЗУЛЬТАТЕ ТАКОГО ИСПОЛЬЗОВАНИЯ. КРОМЕ ТОГО, КОМПАНИЯ
                TREND НАСТОЯЩИМ НАПРЯМУЮ ОТКАЗЫВАЕТСЯ ОТ ЛЮБЫХ ИНЫХ ГАРАНТИЙ В
                ОТНОШЕНИИ ПО (КАК ПРЯМЫХ, ТАК И ПОДРАЗУМЕВАЕМЫХ), ВКЛЮЧАЯ
                ГАРАНТИИ ТОВАРНОГО СОСТОЯНИЯ, ПРИГОДНОСТИ ДЛЯ КОНКРЕТНОЙ ЦЕЛИ,
                ОТСУТСТВИЯ НАРУШЕНИЯ ПРАВ НА ОБЪЕКТЫ ИНТЕЛЛЕКТУАЛЬНОЙ
                СОБСТВЕННОСТИ. В НЕКОТОРЫХ ЮРИСДИКЦИЯХ ИСКЛЮЧЕНИЕ ИЛИ ОТКАЗ ОТ
                ПОДРАЗУМЕВАЕМЫХ ГАРАНТИЙ ЗАПРЕЩЕНЫ, ПОЭТОМУ ДАННОЕ ИСКЛЮЧЕНИЕ
                МОЖЕТ НЕ РАСПРОСТРАНЯТЬСЯ НА ВАС. КОМПАНИЯ TREND НЕ ГАРАНТИРУЕТ,
                ЧТО НИКТО НЕ БУДЕТ ВМЕШИВАТЬСЯ В ИСПОЛЬЗОВАНИЕ ВАМИ ПО, ЧТО
                ФУНКЦИИ ПО ИЛИ СЕРВИСЫ, ОБЕСПЕЧИВАЕМЫЕ ПО, БУДУТ УДОВЛЕТВОРЯТЬ
                ВАШИМ ТРЕБОВАНИЯМ, ЧТО РАБОТА ПО ИЛИ СЕРВИСОВ БУДЕТ
                БЕСПЕРЕБОЙНОЙ ИЛИ БЕЗОШИБОЧНОЙ ИЛИ ЧТО ДЕФЕКТЫ В ПО ИЛИ СЕРВИСАХ
                БУДУТ УСТРАНЯТЬСЯ. УСТНАЯ ИЛИ ПИСЬМЕННАЯ ИНФОРМАЦИЯ ИЛИ
                РЕКОМЕНДАЦИИ, ПРЕДОСТАВЛЯЕМЫЕ КОМПАНИЕЙ TREND ИЛИ ЕЕ
                УПОЛНОМОЧЕННЫМИ ПРЕДСТАВИТЕЛЯМИ, НЕ ЯВЛЯЮТСЯ ГАРАНТИЕЙ.
              </li>
              <li>
                ВЫ ПОНИМАЕТЕ И НАПРЯМУЮ СОГЛАШАЕТЕСЬ С ТЕМ, ЧТО, ЗА ИСКЛЮЧЕНИЕМ
                СЛУЧАЕВ, ПРЕДУСМОТРЕННЫХ СТАТЬЕЙ 10.1, НАШИ ДОЧЕРНИЕ
                ОРГАНИЗАЦИИ, АФФИЛИРОВАННЫЕ ЛИЦА И ЛИЦЕНЗИАРЫ НЕ НЕСУТ ПЕРЕД
                ВАМИ ОТВЕТСТВЕННОСТИ НИ В КАКОЙ ФОРМЕ ЗА УБЫТКИ ИЛИ УЩЕРБ ЛЮБОГО
                ХАРАКТЕРА И РАЗМЕРА, НЕЗАВИСИМО ОТ ТОГО, ЯВЛЯЮТСЯ ЛИ ОНИ
                ПРЯМЫМИ, КОСВЕННЫМИ, СЛУЧАЙНЫМИ, ОСОБЫМИ ИЛИ ШТРАФНЫМИ, В ТОМ
                ЧИСЛЕ В СЛУЧАЕ ПРИЧИНЕНИЯ ВАМ ТАКИХ УБЫТКОВ ИЛИ УЩЕРБА В
                РЕЗУЛЬТАТЕ ИСПОЛЬЗОВАНИЯ ВАМИ ПО, ВКЛЮЧАЯ ПОТЕРЮ ДАННЫХ И
                ПРИЧИНЕНИЕ УЩЕРБА ВАШИМ УСТРОЙСТВАМ, А ТАКЖЕ НЕЗАВИСИМО ОТ ТОГО,
                СООБЩАЛОСЬ ЛИ ВАМ ИЛИ ВАШИМ ПРЕДСТАВИТЕЛЯМ ИЛИ ВЫ (ВАШИ
                ПРЕДСТАВИТЕЛИ) ЗНАЛИ О ВОЗМОЖНОСТИ ВОЗНИКНОВЕНИЯ ТАКИХ УБЫТКОВ.
              </li>
              <li>
                ПРОСЬБА СОХРАНЯТЬ РЕЗЕРВНЫЕ КОПИИ КОНТЕНТА И ДАННЫХ,
                ИСПОЛЬЗУЕМЫХ ВАМИ В СВЯЗИ С ПО. КОМПАНИЯ TREND РЕКОМЕНДУЕТ ВАМ
                СОХРАНЯТЬ РЕЗЕРВНЫЕ КОПИИ ЛЮБОГО КОНТЕНТА И ДАННЫХ, ИСПОЛЬЗУЕМЫХ
                В СВЯЗИ С ПО, В ЦЕЛЯХ ИХ ЗАЩИТЫ В СЛУЧАЕ ВОЗНИКНОВЕНИЯ ПРОБЛЕМ С
                ПО.
              </li>
            </ol>
          </li>

          <li>
            <b> ВНЕСЕНИЕ ИЗМЕНЕНИЙ В ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</b>
            <br />
            Компания TREND вправе вносить изменения в Пользовательское
            соглашение, включая изменение стоимости использования ПО, направив
            вам уведомление с указанием соответствующего изменения по
            электронной почте, через Интернет, через ПО или иным образом, и
            такое изменение вступает в силу в течение 30 (тридцати) дней с даты
            такого уведомления. Вы должны принять изменение в порядке, указанном
            в уведомлении. Если вы не примете изменение, компания TREND вправе
            расторгнуть настоящее Пользовательское соглашение, направив вам
            уведомление за 1 (один) месяц до даты расторжения.
          </li>

          <li>
            <b> УВЕДОМЛЕНИЯ </b>
            <ol>
              <li>
                Любые уведомления и прочие сообщения, направляемые стороне по
                настоящему Пользовательскому соглашению или в связи с ним,
                должны оформляться в письменной форме и доставляться лично,
                заказным письмом с предоплатой почтовых расходов или курьерской
                службой, осуществляющей доставку на следующий рабочий день, по
                адресу зарегистрированного офиса (в случае компании) или
                основному месту ведения деятельности (в любых иных случаях).
              </li>
              <li>
                Все уведомления и другие сообщения считаются доставленными: (i)
                при личной доставке — в момент подписания расписки в получении
                уведомления или в момент оставления уведомления по
                соответствующему адресу; (ii) при отправке заказным письмом с
                предоплатой почтовых расходов или курьерской службой,
                осуществляющей доставку на следующий рабочий день, — на второй
                рабочий день после отправки или в то время, которое указано в
                расписке в получении уведомления; (iii) при отправке по
                электронной почте — в момент передачи или (если сообщение было
                отправлено за пределами рабочего дня в месте получения) в начале
                рабочего дня (то есть с 09:00 до 17:00 с понедельника по
                пятницу, при условии, что день не является государственным
                праздником в месте получения уведомления).
              </li>
            </ol>
          </li>

          <li>
            <b> ПРИМЕНИМОЕ ЗАКОНОДАТЕЛЬСТВО И ПОДСУДНОСТЬ </b>
            Настоящее Пользовательское соглашение и любые споры или требования,
            вытекающие из предмета или заключения настоящего Соглашения или в
            связи с ним (в том числе внедоговорного характера), регулируются и
            толкуются в соответствии с правом Англии и Уэльса. Каждая из сторон
            соглашается в безотзывном порядке, что суды Англии и Уэльса имеют
            исключительную компетенцию разрешать любые споры или требования (в
            том числе внедоговорного характера), вытекающие из настоящего
            Пользовательского соглашения, его предмета или заключения или в
            связи с настоящим Соглашением, его предметом или заключением.
          </li>

          <li>
            <b>ПРОЧИЕ ПОЛОЖЕНИЯ</b>
            <br />
            Настоящее Пользовательское соглашение (включая любые дополнительные
            соглашения к нему или внесенные в него изменения) составляет всю
            полноту соглашений между вами и компанией TREND в отношении ПО и
            услуг поддержки (при предоставлении) и заменяет все предыдущие или
            текущие устные/письменные коммуникации между сторонами, предложения
            и заявления в отношении ПО или любого иного предмета, включенного в
            настоящее Пользовательское соглашение. Если условия той или иной
            политики или правил компании TREND противоречат условиям настоящего
            Пользовательского соглашения, преимущество имеют условия настоящего
            Соглашения. Если то или иное положение настоящего Пользовательского
            соглашения признается ничтожным, недействительным, не имеющим
            исковой силы или незаконным, такое условие будет считаться
            измененным для приведения его в соответствие с применимым
            законодательством и в целях обеспечения отражения изначального
            намерения сторон в максимально возможной степени. Все остальные
            положения при этом сохраняют свою силу. Если компания TREND не
            реализует или не обеспечит исполнение какого-либо права или
            положения настоящего Пользовательского соглашения, это не будет
            являться отказом от такого права или положения, если иное не будет
            признано и согласовано компанией TREND в письменной форме. Ни
            поведение сторон, ни какие-либо методы ведения бизнеса не могут
            изменить положения настоящего Пользовательского соглашения. Вы не
            вправе уступать настоящее Пользовательское соглашение или права по
            нему без предварительного письменного согласия компании TREND,
            предоставляемого ею по ее собственному усмотрению. Попытка уступки
            без такого согласия является ничтожной. С учетом вышеуказанного
            ограничения, настоящее Пользовательское соглашение является
            обязательным для компании TREND и ее правопреемников, заключено в
            интересах указанных лиц и может быть принудительно исполнено
            указанными лицами. Компания TREND вправе передать свои права и
            обязательства по настоящим условиям другой организации.
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;



// WEBPACK FOOTER //
// ./src/components/signup/termsAndCondition/components/russian.js